import { createContext } from 'react';
import { SidebarMenuContainer } from './styled.js';
import { jsx } from 'react/jsx-runtime';

var SidebarMenuContext = /*#__PURE__*/createContext(null);
function SidebarMenu(props) {
  var _props$minimized = props.minimized,
    minimized = _props$minimized === void 0 ? false : _props$minimized,
    children = props.children,
    className = props.className,
    onToggle = props.onToggle;
  var toggleMinimized = function toggleMinimized() {
    if (onToggle) {
      onToggle();
    }
  };
  var value = {
    minimized: minimized,
    toggleMinimized: toggleMinimized
  };
  return /*#__PURE__*/jsx(SidebarMenuContext.Provider, {
    value: value,
    children: /*#__PURE__*/jsx(SidebarMenuContainer, {
      $minimized: minimized,
      className: className,
      children: children
    })
  });
}

export { SidebarMenu, SidebarMenuContext };
